<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [rowClassRules]="rowDisableRules" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
    [responseCallback]="responseCallback" [gridContext]="gridContext" [pagerVisible]="false"
    [updateStatusType]="'CUSTOM_FIELD'">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" *ngIf="hasPermissions" data-automation-id="organization-settings-add-new-custom-field-button"
        class="secondary-button" (click)="addNewCustomField()">
        <i class="fa fa-plus"></i>New Custom Field ...
    </button>
</ng-template>